import { Box, Typography } from "@mui/material";
import React from "react";

// generic function to format price without formatting
export function formatPrice(price) {
  let formattedPrice = "0.00";
  try {
    price = parseFloat(price);
    if (typeof price === "number" && !isNaN(price)) {
      // Assuming price is a number
      formattedPrice = price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      // const formattedPrice = price.toFixed(2).toLocaleString();
    }
  } catch (error) {
    console.error("Error formatting price:", error);
  }
  return formattedPrice;
}

// format price to add commas without forcing them to 2 decimal places at the back. 
export function formatInputWithCommas (value){
  try{
    if (value !== '' && value !== null && value !== undefined) { 
      let valueString = value.toString();
      // Split the value into integer and fractional parts
      let [integer, fraction] = valueString.split('.');
      // Remove non-numeric characters from the integer part
      integer = integer.replace(/\D/g, '');
      // Format the integer part with commas
      const formattedInteger = new Intl.NumberFormat('en-US').format(integer);
      // If there's a fractional part, limit it to 2 decimal places
      if (fraction !== undefined) {
        fraction = fraction.substring(0, 2); // Adjust the substring length as needed
        return `${formattedInteger}.${fraction}`;
      }

      // If the user has typed a dot, keep it at the end
      return valueString.includes('.') ? `${formattedInteger}.` : formattedInteger;
    }
  } catch (error) {
    console.error("Error formatting price:", error);
  }
};

// generic function to remove formatting from price that has comma to return a pure number
export function unformatPrice(price) {
  let unformattedPrice = 0;
  try {
    unformattedPrice = parseFloat(price.replace(/,/g, ''));
  } catch (error) {
    console.error("Error unformatting price:", error);
  }
  return unformattedPrice;
}


function PriceFormatter({ price }) {
  // try to parse price to number even if it is a string
  price = parseFloat(price);
  if (typeof price === "number" && !isNaN(price)) {
    // Assuming price is a number
    const formattedPrice = price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    // const formattedPrice = price.toFixed(2).toLocaleString();

    return (
      <Box>
        <Typography sx={{ display: "inline-flex", marginRight: "3%" }}>
        <span style={{ fontSize: '11px' }}>RM</span>
        </Typography>
        {formattedPrice}
      </Box>
    );
  } else {
    // Return a default message or empty div if price is not valid
    return (
      <Box>
        <Typography sx={{ display: "inline-flex", marginRight: "3%" }}>
          RM 0.00
        </Typography>
      </Box>
    );
  }
}

export default PriceFormatter;
